import { RoutePaths } from './constants';

export const getRoute = (route: RoutePaths, id: string | number) => {
  return route.replace(`:id`, id.toString());
};
export const getPermission = (user: any, key: string) => {
  return user?.rolePermission?.find((p: any) => p.menuKey === key)?.permissions;
};
export const reload = () => {
  window.location.reload();
};
